import { useModalContentToggler } from '@components'

import { Color, Icon, SkeletonBox, Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'
import { useCurrentUser } from '@modules-deprecated/app/user'

import { useShineConnectModal } from '../../contexts/shineConnectModalContext'
import { CreateBankConnectionModalSteps } from '../../enums/createBankConnectionModalSteps'
import { ProductSource } from '../../enums/productSource'
import { OrganizationInfoBox } from '../OrganizationInfoBox'
import * as Styled from './styles'

export const ConfirmationModalBody = (): ReactElement => {
  const { t } = useTranslation()
  const { user } = useCurrentUser()
  const { organization } = useUserOrganization()
  const { shineOrganizationData, shineUserData, hasValidationFailed, hasValidationSucceeded, isValidating } =
    useShineConnectModal()
  const { setActiveState } = useModalContentToggler()

  const shouldShowError = hasValidationFailed || (hasValidationSucceeded && (!shineOrganizationData || !shineUserData))

  if (!user || !organization) {
    return <></>
  }

  if (shouldShowError) {
    setActiveState(CreateBankConnectionModalSteps.Error)
    return <></>
  }

  if (isValidating || !shineOrganizationData || !shineUserData) {
    return <SkeletonBox />
  }

  return (
    <>
      <Text colorVariant="secondary">{t('bank_connection.shine_connect_modal.description')}</Text>
      <Space size="s24" />
      <Styled.OrganizationCardsWrapper>
        <OrganizationInfoBox
          organizationName={organization.name}
          ownerName={user.name}
          ownerEmail={user.email}
          source={ProductSource.ACCOUNTING}
        />
        <Styled.ConnectIconWrapper>
          <Icon icon="link" color={Color.Grey950} />
        </Styled.ConnectIconWrapper>
        <OrganizationInfoBox
          organizationName={shineOrganizationData.legalName}
          ownerName={shineUserData.firstName + ' ' + shineUserData.lastName}
          ownerPhoneNo={shineUserData.phone}
          source={ProductSource.BANKING}
          siretNo={shineOrganizationData.legalRegistrationNumber ?? undefined}
        />
      </Styled.OrganizationCardsWrapper>
    </>
  )
}
